import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';

import './Breadcrumbs.scoped.scss';

interface IBreadcrumb {
  title: string;
  link: string;
}

interface Props {
  className?: string;
  breadcrumbs: IBreadcrumb[];
}

const Breadcrumbs: React.FC<Props> = ({ className, breadcrumbs }) => {
  const { t } = useTranslation('common');

  return (
    <div className={`breadcrumbs-container ${className}`}>
      {breadcrumbs.map((breadcrumb, index) => (
        <>
          <Link to={breadcrumb?.link} className={!breadcrumb?.link && 'breadcrumbs-active'}>
            {t(breadcrumb.title)}
          </Link>
          {breadcrumbs.length - 1 !== index && <p>→</p>}
        </>
      ))}
    </div>
  );
};

export default memo(Breadcrumbs);
